module.exports = __webpack_public_path__ + "img/中通服.75abd982.png";